'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

var _affiliate = require('./affiliate');

var _affiliate2 = _interopRequireDefault(_affiliate);

var _booking = require('./booking/booking');

var _booking2 = _interopRequireDefault(_booking);

var _bookingList = require('./bookingList');

var _bookingList2 = _interopRequireDefault(_bookingList);

var _buffet = require('./buffet');

var _buffet2 = _interopRequireDefault(_buffet);

var _customize = require('./customize');

var _customize2 = _interopRequireDefault(_customize);

var _dashboard = require('./dashboard');

var _dashboard2 = _interopRequireDefault(_dashboard);

var _digi = require('./digi');

var _digi2 = _interopRequireDefault(_digi);

var _dtac = require('./dtac');

var _dtac2 = _interopRequireDefault(_dtac);

var _profile = require('./profile');

var _profile2 = _interopRequireDefault(_profile);

var _gallery = require('./gallery');

var _gallery2 = _interopRequireDefault(_gallery);

var _home = require('./home');

var _home2 = _interopRequireDefault(_home);

var _info = require('./info');

var _info2 = _interopRequireDefault(_info);

var _inspiration = require('./inspiration');

var _inspiration2 = _interopRequireDefault(_inspiration);

var _inspirations = require('./inspirations');

var _inspirations2 = _interopRequireDefault(_inspirations);

var _loader = require('./loader');

var _loader2 = _interopRequireDefault(_loader);

var _lxprofile = require('./lxprofile');

var _lxprofile2 = _interopRequireDefault(_lxprofile);

var _lockscreen = require('./lockscreen');

var _lockscreen2 = _interopRequireDefault(_lockscreen);

var _listing = require('./listing');

var _listing2 = _interopRequireDefault(_listing);

var _messageTemplate = require('./messageTemplate');

var _messageTemplate2 = _interopRequireDefault(_messageTemplate);

var _payment = require('./payment');

var _payment2 = _interopRequireDefault(_payment);

var _popup = require('./popup');

var _popup2 = _interopRequireDefault(_popup);

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _suggestion = require('./suggestion');

var _suggestion2 = _interopRequireDefault(_suggestion);

var _toast = require('./toast');

var _toast2 = _interopRequireDefault(_toast);

var _trip = require('./trip');

var _trip2 = _interopRequireDefault(_trip);

var _calendar = require('./calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _availability = require('./availability');

var _availability2 = _interopRequireDefault(_availability);

var _initialLoadSuccess = require('./initialLoadSuccess');

var _initialLoadSuccess2 = _interopRequireDefault(_initialLoadSuccess);

var _wishlist = require('./wishlist');

var _wishlist2 = _interopRequireDefault(_wishlist);

var _language = require('./language');

var _language2 = _interopRequireDefault(_language);

var _redirect = require('./redirect');

var _redirect2 = _interopRequireDefault(_redirect);

var _review = require('./review');

var _review2 = _interopRequireDefault(_review);

var _swapRequest = require('./swapRequest');

var _swapRequest2 = _interopRequireDefault(_swapRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// *
exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  app: _app2.default,
  affiliate: _affiliate2.default,
  booking: _booking2.default,
  bookingList: _bookingList2.default,
  buffet: _buffet2.default,
  customize: _customize2.default,
  dashboard: _dashboard2.default,
  digi: _digi2.default,
  dtac: _dtac2.default,
  // form,
  profile: _profile2.default,
  gallery: _gallery2.default,
  home: _home2.default,
  info: _info2.default,
  inspiration: _inspiration2.default,
  inspirations: _inspirations2.default,
  lxprofile: _lxprofile2.default,
  listing: _listing2.default,
  loader: _loader2.default,
  lockscreen: _lockscreen2.default,
  messageTemplate: _messageTemplate2.default,
  payment: _payment2.default,
  popup: _popup2.default,
  search: _search2.default, // *
  session: _session2.default,
  suggestion: _suggestion2.default,
  toast: _toast2.default,
  trip: _trip2.default,
  calendar: _calendar2.default,
  availability: _availability2.default,
  initialLoadSuccess: _initialLoadSuccess2.default,
  wishlist: _wishlist2.default,
  language: _language2.default,
  redirect: _redirect2.default,
  review: _review2.default,
  swapRequest: _swapRequest2.default
});
// import {reducer as form} from 'redux-form';

// import booking from './booking';

// import { routeReducer } from 'react-router-redux';

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 1705
// module chunks = 47